import type { Theme } from "@mui/material/styles";
import { buildReportChatDataTableCustomStyles } from "../../assets/theme/custom/components/dataTable";

export type ReportChatShellColors = Theme["palette"]["reportChat"];

/** Report / chat shell colors from the active MUI theme palette. */
export function getReportChatShell(theme: Theme): ReportChatShellColors {
  return theme.palette.reportChat;
}

/** @deprecated Use getReportChatShell(theme) — kept for legacy boolean darkMode call sites during migration. */
export function getReportChatShellByMode(darkMode: boolean): ReportChatShellColors {
  void darkMode;
  throw new Error("Use getReportChatShell(theme) with useTheme() instead of darkMode boolean.");
}

/** react-data-table-component customStyles aligned with chat main canvas (`appBg`). */
export function getReportChatDataTableCustomStyles(theme: Theme) {
  return buildReportChatDataTableCustomStyles(theme);
}
